// --------------------------------------------------------------
// Created On: 2025-06-25
// Author: Hannah Vaughan
//
// Last Modified: 2025-10-27
// Modified By: Zachary Thomas
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import React from "react";
import styles from "./ErrorBanner.module.scss";

// Error message.
export default function ErrorBanner(props: Props): Component {
  return props.message.length > 0 ? (
    <div data-test="error-banner" className={`${styles.body} alert alert-danger`} role="alert">
      <span>{props.message}</span>
      {props.children !== undefined && props.children}
    </div>
  ) : null;
}

interface Props {
  message: string;
  children?: Children;
}
